import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

export interface ScopeItemState {
  state: boolean;
  title: string;
  content: string;
  linkTitle: string;
}

export interface ScopeState {
  [key: string]: ScopeItemState;
}

export enum AvailableScope {
  main = 'main'
}

export type DataErrorState = EntityState<ScopeState>

function createInitialState(): DataErrorState {
  const initialState = {};

  for (const scope in AvailableScope) {
    if (!Number(scope)) {
      initialState[AvailableScope[scope]] = {
        state: false,
        title: '',
        content: '',
        linkTitle: ''
      };
    }
  }

  return initialState;
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: 'DataError' })
export class DataErrorStore extends EntityStore<DataErrorState, ScopeState> {
  constructor() {
    super(createInitialState());
  }
}
